const HomeColors = {
    colors: {
        color1: '#483c0c', // Equivalente aproximado de '#480c0c'
        color2: '#655117', // Equivalente aproximado de '#651717'
        color3: '#816820', // Equivalente aproximado de '#812020'
        color4: '#b69749', // Equivalente aproximado de '#b64949'
        color5: '#c5a667', // Equivalente aproximado de '#c56767'
        color6: '#d3c5a6', // Equivalente aproximado de '#d5a6a6'
    },
}

export default HomeColors;